export default "/_next/static/chunks/fonts/IBM Plex Sans ExtraLight-201d39679b89ecb6fabf7a10176233b3.ttf";